module.exports = __webpack_public_path__ + "static/media/222.987b9498.wav";